import React, { Suspense}  from "react";
import {  Loader } from 'semantic-ui-react'

const withSuspense = (Component) => (props) => (
	<Suspense fallback={<div className="suspense-style"><Loader active inline /></div>}>
		<Component {...props} />
	</Suspense>
);

export default withSuspense;